import React, { useEffect, useState } from 'react';

export default function ParametersForm(props) {
    const [nameParam, setNameParam] = useState('');
    const [descriptionParam, setDescriptionParam] = useState('');
    const [valueDataParam, setValueDataParam] = useState('');
    const [estatusParam, setEstausParam] = useState('');
    useEffect(() => {
        if (props.formData.length > 0) {
            const datForm = props.formData[0];
            setNameParam(datForm["name"]);
            setDescriptionParam(datForm["description"]);
            setValueDataParam(datForm["valueData"]);
            setEstausParam(datForm["status"]);
        } else {
            setNameParam(localStorage.getItem("nameParam"));
            setDescriptionParam(localStorage.getItem("descriptionParam"));
            setValueDataParam(localStorage.getItem("valueDataParam"));
            setEstausParam(localStorage.getItem("estausParam"));
        }
    }, [props]);
    return (
        <>
            <div className="row">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Nombre</label>
                                <input id="nameParam"
                                    name="nameParam"
                                    type="text"
                                    maxLength={20}
                                    value={nameParam}
                                    onChange={e => {
                                        setNameParam(e.target.value.replace(/[^a-z\s]/gi, ''))
                                        localStorage.setItem('nameParam', e.target.value.replace(/[^a-z\s]/gi, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar nombre" />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Descripción</label>
                                <input id="description"
                                    name="description"
                                    type="text"
                                    maxLength={100}
                                    value={descriptionParam}
                                    onChange={e => {
                                        setDescriptionParam(e.target.value.replace(/[^a-z\s]/gi, ''))
                                        localStorage.setItem('descriptionParam', e.target.value.replace(/[^a-z\s]/gi, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar una descripción" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>valor (En porcentaje)</label>
                                <input id="valueParam"
                                    name="valueParam"
                                    maxLength={10}
                                    type="text"
                                    value={valueDataParam}
                                    onChange={e => {
                                        setValueDataParam(e.target.value.replace(/\D/g, ''))
                                        localStorage.setItem('valueDataParam', e.target.value.replace(/\D/g, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar valor en porcentaje" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Estado</label>
                                <div className="custom-control custom-switch">
                                    {
                                        estatusParam === "Activo"
                                            ?
                                            <input type="checkbox" onChange={e => setEstausParam(e.target.value)} checked className="custom-control-input" id="statusSiwtch" />
                                            :
                                            <input type="checkbox" onChange={e => setEstausParam(e.target.value)} className="custom-control-input" id="statusSiwtch" />

                                    }

                                    <label className="custom-control-label" htmlFor="statusSiwtch">{estatusParam}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}
